import { CATEGORY_MENU_DATA_URL } from 'aster-foundation/core/common/utils/ApiConst';

let paramsList = null;

const defaultParams = {
  ecommerce: null,
  user_state: '',
  product_type: '',
  product_sku: '',
  productName: '',
  brand: '',
  productCategory: '',
  productId: '',
  Product_price: '',
  delivery_promise: '',
  listing_items: null,
  search_term: '',
  category_brand_type: '',
  result_ids: null,
  service_type: null,
  page_type: null,
  screen_name: null,
};

const getParamsList = async () => {
  try {
    const GTM_DATA_URL = `${CATEGORY_MENU_DATA_URL}/static/json/GTM-parameter-cleanup.json`;
    const response = await fetch(GTM_DATA_URL);
    const data = await response.json();
    paramsList = data;
  } catch (e) {
    paramsList = defaultParams;
  }
};

export const clearDataLayerParams = () => {
  if (!paramsList) getParamsList();
  typeof window !== 'undefined' ? window.dataLayer?.push({ ...paramsList }) : '';
};
